import {Component, OnDestroy, OnInit} from '@angular/core';
import '../../../assets/Build/UnityLoader';
import {UnityChartService} from './unity-chart.service';

declare var UnityLoader: any;

@Component({
    selector: 'app-unity-chart',
    templateUrl: './unity-chart.component.html',
    styleUrls: [],
    providers: []
})
export class UnityChartComponent implements OnInit, OnDestroy {

    gameInstance: any;

    public progress: number;
    public unityChartReady: boolean;
    private unityObjectName: string;
    private data: any;

    constructor(
        private unityChartService: UnityChartService
    ) {
    }

    ngOnInit() {

        this.progress = 0;
        this.unityObjectName = 'StackGraphCoordinator';
        this.unityChartReady = false;
        this.data = null;

        (window as any).UnityReadyForData = (response: string) => {
            const responseSplit = response.split('|');
            if (responseSplit.length === 3) {
                this.unityObjectName = responseSplit[0].trim();
                const level = Number(responseSplit[1].trim());
                const id = Number(responseSplit[2].trim());

                // console.log('Unity says it is ready. Data received: ' + response);
                // console.log('Level ' + level);
                // console.log('ID ' + id);

                if (level > 0) {
                    this.unityChartService.drillDown(id, level);
                    this.unityChartService.next({});
                } else {
                    if (this.data !== null) {
                        this.sendMessage();
                    }
                }

                this.unityChartReady = true;
            }
        };

        this.gameInstance = UnityLoader.instantiate('gameContainer', 'assets/Build/webGLOutput.json', {
            onProgress: (gameInstance: any, progress: number) => {
                this.progress = (0.98 * progress);
            }
        });
    }

    ngOnDestroy() {
        this.unityChartReady = false;
        if (this.gameInstance) {
            this.gameInstance.Quit();
        }
    }

    public displayData(data: any) {
        this.data = data;
        if (this.unityChartReady) {
            this.sendMessage();
        }
    }

    private sendMessage() {
        this.gameInstance.SendMessage(this.unityObjectName, 'SetJSON', JSON.stringify(this.data));
    }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/components/unity-chart/unity-chart.component.ts